import { render, staticRenderFns } from "./regular-num.vue?vue&type=template&id=0ff10b30&scoped=true&"
import script from "./regular-num.vue?vue&type=script&lang=js&"
export * from "./regular-num.vue?vue&type=script&lang=js&"
import style0 from "./regular-num.vue?vue&type=style&index=0&id=0ff10b30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff10b30",
  null
  
)

export default component.exports